import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Roboto\",\"arguments\":[{\"variable\":\"--font-roboto\",\"subsets\":[\"latin\"],\"weight\":[\"100\",\"300\",\"400\",\"500\",\"700\",\"900\"]}],\"variableName\":\"roboto\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Big_Shoulders_Display\",\"arguments\":[{\"variable\":\"--font-big-shoulders\",\"subsets\":[\"latin\"],\"weight\":[\"100\",\"200\",\"300\",\"400\",\"500\",\"600\",\"700\",\"800\",\"900\"]}],\"variableName\":\"bigShoulders\"}");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/app/node_modules/sonner/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/src/app/globals.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/swiper/swiper-bundle.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/react-photo-view/dist/react-photo-view.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/nouislider/dist/nouislider.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/react-circular-progressbar/dist/styles.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/common/popup/GlobalVideoModal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/contextApi/AppProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VideoProvider"] */ "/app/src/contextApi/VideoProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/redux/provider.tsx");
